import { useEffect } from "react";

const useAntdClearButtonA11y = () => {
  useEffect(() => {
    const attachClearKeyHandler = (clearBtn) => {
      if (!clearBtn || clearBtn.dataset.keyHandlerAttached) return;

      clearBtn.setAttribute("tabindex", "0");
      clearBtn.setAttribute("role", "button");
      clearBtn.setAttribute("aria-label", "Clear search");

      clearBtn.dataset.keyHandlerAttached = "true";

      const onFocus = () => {
        clearBtn.style.outline = "2px solid #1d4ed8";
        clearBtn.style.outlineOffset = "2px";
        clearBtn.style.borderRadius = "50%";
        clearBtn.style.backgroundColor = "rgba(29, 78, 216, 0.1)";
      };

      const onBlur = () => {
        clearBtn.style.outline = "";
        clearBtn.style.outlineOffset = "";
        clearBtn.style.borderRadius = "";
        clearBtn.style.backgroundColor = "";
      };

      const onKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          clearBtn.click();
        }
      };

      clearBtn.addEventListener("focus", onFocus);
      clearBtn.addEventListener("blur", onBlur);
      clearBtn.addEventListener("keydown", onKeyDown);
    };

    const scanAndAttach = () => {
      const allClearButtons = document.querySelectorAll(".ant-input-clear-icon");
      allClearButtons.forEach(attachClearKeyHandler);
    };

    // Initial run
    scanAndAttach();

    // Watch DOM changes
    const observer = new MutationObserver(() => {
      scanAndAttach();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
};

export default useAntdClearButtonA11y;
